import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  successContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "25px",
  },
  successImg: {
    width: "64px",
    height: "64px",
  },
  successTitle: {
    fontWeight: 700,
    fontSize: "18px",
    margin: 0,
    color: "#3D3D3D",
    padding: "10px 0px",
  },
  message: {
    fontWeight: 500,
    fontSize: "14px",
    margin: 0,
    color: "#7A7A7A",
    marginBottom: "65px !important",
  },
}));
